/** @jsx jsx */
import NumberFormat from 'react-number-format';
import { useTranslation } from 'react-i18next';
import { jsx } from '@emotion/core';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';
import { StyledChip, StyledLabelContainer, StyledLabelText } from './styles';
import { IFormProduct } from 'components/DeclarationForm/interfaces';

export const NbOfResultsChip = ({
  selectedProducts,
}: {
  selectedProducts: IFormProduct[];
}): JSX.Element => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledChip
      isMobile={isMobile}
      label={
        <StyledLabelContainer>
          <NumberFormat
            value={selectedProducts.length}
            displayType="text"
            thousandSeparator=" "
          />
          <StyledLabelText>
            {t('challenges.declaration.enteredResults', {
              count: selectedProducts.length,
            })}
          </StyledLabelText>
        </StyledLabelContainer>
      }
    />
  );
};
